module.exports = __webpack_public_path__ + "img/invoices.f3f76e68.svg";